/**
 * Product configuration for JavaCard products
 * Centralized product information to avoid duplication
 */

export const PRODUCTS = {
  satochip: {
    id: 'satochip',
    repoName: 'SatochipApplet',
    capFileName: 'SatoChip-3.0.4.cap',
    repoUrl: 'https://github.com/Toporin/SatochipApplet',
    buyUrl: 'https://satochip.io/product/satochip/',
    downloadUrl: 'https://github.com/Toporin/SatochipApplet/releases/download/v0.12/SatoChip-0.12-05.cap',
    releasesUrl: 'https://github.com/Toporin/SatochipApplet/releases/tag/v0.12'
  },
  seedkeeper: {
    id: 'seedkeeper',
    repoName: 'Seedkeeper-Applet',
    capFileName: 'SeedKeeper-3.0.4.cap',
    repoUrl: 'https://github.com/Toporin/Seedkeeper-Applet',
    buyUrl: 'https://satochip.io/product/seedkeeper/',
    releasesUrl: 'https://github.com/Toporin/Seedkeeper-Applet/releases'
  },
  satodime: {
    id: 'satodime',
    repoName: 'Satodime-Applet',
    capFileName: 'Satodime-3.0.4.cap',
    repoUrl: 'https://github.com/Toporin/Satodime-Applet',
    buyUrl: 'https://satochip.io/product/satodime/',
    releasesUrl: 'https://github.com/Toporin/Satodime-Applet/releases'
  }
};

/**
 * Get product configuration by product ID
 * @param {string} productId - 'satochip' | 'seedkeeper' | 'satodime'
 * @returns {Object} Product configuration object
 */
export const getProductConfig = (productId) => {
  return PRODUCTS[productId] || PRODUCTS.satochip; // Default to satochip
};

